import type { AdIntelligenceRecordsSearchAdvertiserSpendResponse } from "@similarweb/pro-api-client";

import { apiClient } from "app/modules/api-client";

import { toSearchAdsSpendListParams } from "./searchAdsSpendParams";
import type { ISearchAdsSpendQueryParams } from "./types";

/** Promise-based entry point for the dashboard widgets, which live outside the React tree. */
export const fetchSearchAdsSpend = (
    params: ISearchAdsSpendQueryParams,
): Promise<AdIntelligenceRecordsSearchAdvertiserSpendResponse> =>
    apiClient.AdSpend.adintelligenceSearchAdsSpendList(toSearchAdsSpendListParams(params));
